import React, { Component } from 'react';
import { RENAME_COLUMNS } from '../../util/enums/EnumLayers';
import ColumnRenderer from '../../util/ColumnRenderer';
import ColumnsSelector from '../ColumnsSelector';

class ModalRenameColumns extends Component {
  static modalType() {
    return RENAME_COLUMNS;
  }

  static reducer(modals) {
    return modals.renameColumnsModal;
  }

  static title() {
    return 'Rename columns';
  }

  static subTitle() {
    return 'Rename one or multiple columns';
  }

  render() {
    const { userInteraction, state, usedAliases, columns } = this.props;

    const rows = [];
    state.existing.forEach((existing, index) => {
      const name = state.names[index];
      const onNameChange = (e) => {
        const props = {
          section: 'nameChanged',
          index,
          newValue: e.target.value,
        };
        userInteraction(props)();
      };
      const remove = () => {
        userInteraction({ section: 'remove', index })();
      };
      const tableName = !existing.alias() ? null : (
        <span className="faint">({usedAliases[existing.alias()].name()})</span>
      );
      rows.push(
        <tr key={index}>
          <td className="modal_label">Rename</td>
          <td className="modal_label word-wrap">
            <b>{existing.name()}</b> <small>{tableName}</small>
          </td>
          <td className="modal_label">to</td>
          <td>
            <input
              type="text"
              className="form-control min-width-100"
              onChange={onNameChange}
              value={name}
              placeholder="new name"
            />
          </td>
          <td>
            <button
              type="button"
              className="btn btn-outline-dark"
              onClick={remove}
            >
              <span className="glyphicon glyphicon-remove" />
            </button>
          </td>
        </tr>,
      );
      if (
        columns.findIndex(
          (c) => !c.name().alias() && c.name().name() === name,
        ) !== -1
      ) {
        rows.push(
          <tr key={`error${index}`}>
            <td colSpan={5}>
              <div className="alert alert-danger" role="alert">
                Column name <b>{name}</b> already in use
              </div>
            </td>
          </tr>,
        );
      }
    });

    const columnsToChoose = columns.filter(
      (c) => state.existing.findIndex((cn) => cn.equals(c.name())) === -1,
    );
    if (columnsToChoose.length > 0) {
      if (state.moreClicked) {
        const renderer = new ColumnRenderer(
          'lhs',
          userInteraction,
          usedAliases,
        );
        rows.push(
          <tr key="column-selector">
            <td className="modal_label">Rename</td>
            <td>
              <ColumnsSelector
                values={columnsToChoose.map((c) => c.name())}
                renderer={renderer}
              />
            </td>
          </tr>,
        );
      } else {
        rows.push(
          <tr key="more">
            <td>
              <button
                type="button"
                className="btn btn-outline-dark"
                onClick={userInteraction({ section: 'moreClicked' })}
              >
                <span className="glyphicon glyphicon-plus" />
              </button>
            </td>
          </tr>,
        );
      }
    }

    return (
      <table>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}

export default ModalRenameColumns;
